// extracted by mini-css-extract-plugin
export default {"Container":"Footer_Container__5EyJ6","Links":"Footer_Links__DcAT+","ContainerLight":"Footer_ContainerLight__4lR42","LinksDarker":"Footer_LinksDarker__iO8pS"};